import { fmtDate, fmtDateTime } from "@/lib/checkins";
import { AlertRow } from "./AlertRow";
import { DiarySummaryPdf } from "./DiaryPdfButtons";
import { DiaryReport } from "./DiaryReport";
import { DiaryReviewForm } from "./DiaryReviewForm";

const H = ({ children }) => <h3 className="mt-5 mb-2 font-display text-base font-semibold text-zinc-950">{children}</h3>;

/** Body of the submission dialog for a finished diary. `notes` is the shared notes block. */
export function DiarySubmission({ sub, staff, readOnly, onChanged, notes }) {
  const how = sub.finalised_by === "window_closed" ? "automatically when the diary closed" : "by the client";
  return (
    <div data-testid="diary-submission">
      <div className="flex flex-wrap items-start gap-3">
        <p className="flex-1 text-sm text-zinc-600" data-testid="checkin-submission-meta">
          Diary {fmtDate(sub.period?.start)} – {fmtDate(sub.period?.end)} · sent {how} {fmtDateTime(sub.submitted_at)} · v{sub.semantic_version}
          {sub.source === "assisted" && " · practitioner-assisted"}
        </p>
        <DiarySummaryPdf sub={sub} />
      </div>
      <div className="mt-3">
        <DiaryReport config={sub.diary_config} diary={sub.diary} summary={sub.diary_summary} flags={sub.diary_flags} start={sub.period?.start} />
      </div>
      {sub.alerts.length > 0 && (
        <><H>Alerts & tasks</H><div className="space-y-2">{sub.alerts.map((a) => <AlertRow key={a.id} alert={a} staff={staff} onChanged={onChanged} readOnly={readOnly} showClient={false} />)}</div></>
      )}
      <H>Practitioner review</H>
      <DiaryReviewForm sub={sub} readOnly={readOnly} onDone={onChanged} />
      <H>Notes</H>
      {notes}
      <p className="mt-4 text-2xs text-zinc-400">{sub.evidence_note}</p>
    </div>
  );
}
